import { useQueryClient } from "@tanstack/react-query";

import { usePostControlProgramsTagCategories } from "api/generated/control-program/control-program";

import { CONTROL_PROGRAM_TAGS_QUERY_KEY } from "./useControlProgramTagsQuery";

export function useCreateControlProgramTagCategoryMutation() {
    const queryClient = useQueryClient();

    return usePostControlProgramsTagCategories({
        mutation: {
            onSuccess: () =>
                queryClient.invalidateQueries({
                    queryKey: [CONTROL_PROGRAM_TAGS_QUERY_KEY],
                }),
        },
    });
}
